module.exports = __webpack_public_path__ + "img/tag.ff62920e.svg";